import { makeStyles } from 'e100-react-components';

export const useStyles = makeStyles(({ spacing, palette }) => ({
  icon: {
    verticalAlign: 'top',
    position: 'relative',
    left: spacing(0.5),
  },
  text: {
    position: 'relative',
    top: spacing(0.15),
    color: palette.warning.dark,
  },
  label: {
    display: 'inline-block',
    lineHeight: 1.2
  }
}));
